/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProductGroupDto } from '../models/work-create-product-group-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkItem } from '../models/work-item';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProductgroup } from '../models/work-productgroup';
import { WorkUpdateProductGroupDto } from '../models/work-update-product-group-dto';

@Injectable({ providedIn: 'root' })
export class WorkProductgroupsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productgroupsV2ControllerFindAllPaginated()` */
  static readonly ProductgroupsV2ControllerFindAllPaginatedPath = '/v2/productgroups';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>sortableRank</li>
     * <li>containertypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProductgroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProductgroup>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'containertypeId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>active</li>
     * <li>sortableRank</li>
     * <li>containertypeId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'active:ASC' | 'active:DESC' | 'sortableRank:ASC' | 'sortableRank:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProductgroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}> {
    return this.productgroupsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProductgroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProductgroup>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerCreate()` */
  static readonly ProductgroupsV2ControllerCreatePath = '/v2/productgroups';

  /**
   * Required permissions: items:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productgroupsV2ControllerCreate$Response(
    params: {
      body: WorkCreateProductGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProductgroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProductgroup>;
      })
    );
  }

  /**
   * Required permissions: items:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productgroupsV2ControllerCreate(
    params: {
      body: WorkCreateProductGroupDto
    },
    context?: HttpContext
  ): Observable<WorkProductgroup> {
    return this.productgroupsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProductgroup>): WorkProductgroup => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerGetAllDropdownOptions()` */
  static readonly ProductgroupsV2ControllerGetAllDropdownOptionsPath = '/v2/productgroups/dropdown-options';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.productgroupsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerFindOneById()` */
  static readonly ProductgroupsV2ControllerFindOneByIdPath = '/v2/productgroups/{id}';

  /**
   * Required permissions: items:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProductgroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProductgroup>;
      })
    );
  }

  /**
   * Required permissions: items:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProductgroup> {
    return this.productgroupsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProductgroup>): WorkProductgroup => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerDelete()` */
  static readonly ProductgroupsV2ControllerDeletePath = '/v2/productgroups/{id}';

  /**
   * Required permissions: items:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: items:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.productgroupsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerUpdate()` */
  static readonly ProductgroupsV2ControllerUpdatePath = '/v2/productgroups/{id}';

  /**
   * Required permissions: items:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productgroupsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProductGroupDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProductgroup>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProductgroup>;
      })
    );
  }

  /**
   * Required permissions: items:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productgroupsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProductGroupDto
    },
    context?: HttpContext
  ): Observable<WorkProductgroup> {
    return this.productgroupsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProductgroup>): WorkProductgroup => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerAssignItem()` */
  static readonly ProductgroupsV2ControllerAssignItemPath = '/v2/productgroups/{id}/items/{itemId}';

  /**
   * Required permissions: items:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerAssignItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerAssignItem$Response(
    params: {
      id: number;
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerAssignItemPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * Required permissions: items:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerAssignItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerAssignItem(
    params: {
      id: number;
      itemId: number;
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.productgroupsV2ControllerAssignItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

  /** Path part for operation `productgroupsV2ControllerRemoveItem()` */
  static readonly ProductgroupsV2ControllerRemoveItemPath = '/v2/productgroups/{id}/items/{itemId}';

  /**
   * Required permissions: items:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productgroupsV2ControllerRemoveItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerRemoveItem$Response(
    params: {
      id: number;
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProductgroupsV2Service.ProductgroupsV2ControllerRemoveItemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItem>;
      })
    );
  }

  /**
   * Required permissions: items:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productgroupsV2ControllerRemoveItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productgroupsV2ControllerRemoveItem(
    params: {
      id: number;
      itemId: number;
    },
    context?: HttpContext
  ): Observable<WorkItem> {
    return this.productgroupsV2ControllerRemoveItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItem>): WorkItem => r.body)
    );
  }

}
